import script from "./SendEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendEmail.vue?vue&type=script&lang=ts&setup=true"

import "./SendEmail.vue?vue&type=style&index=0&id=0555fd79&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0555fd79"]])

export default __exports__